import React, { useEffect } from 'react'
import { usePage } from '@inertiajs/react'

import { toast, ToastContainer } from 'react-toastify'

export default () => {
  const { flash, errors } = usePage().props
  const numOfErrors = Object.keys(errors).length

  useEffect(() => {
    if (flash.success) {
      toast.success(flash.success)
    }

    if (flash.error || numOfErrors > 0) {
      if (flash.error) {
        toast.error(flash.error)
      }

      if (numOfErrors === 1) {
        toast.error('There is one form error')
      }

      if (numOfErrors > 1) {
        toast.error(`There are ${numOfErrors} form errors.`)
      }
    }
  }, [flash, errors])

  return <ToastContainer />
}
